import { IAppNotification } from "../../models";


export interface INotificationsState {
   shouldShowNotifcations: boolean
   notifications: IAppNotification[];
}


export const initialState: INotificationsState = {
   shouldShowNotifcations: false,
   notifications: [],
};